/** @format */

import template from './gb-bidding-item-amount.html';

export const GbBiddingItemAmountComponent = {
    template,
    require: {
        gbApp: '^^',
    },
    bindings: {
        biddingItem: '<',
        winningBid: '<?',
    },
    controller: class GbBiddingItemAmountComponent {
        constructor() {
            'ngInject';
        }
    },
};
